import TableUtil from "./TableUtil";
import FieldUtil from "./FieldUtil";
import PageFactory from "./PageFactory";

export default class LayoutFactory {

  constructor(table) {
    this.table = table
    this.tableUtil = new TableUtil()
    this.pageFactory = new PageFactory()
  }

  createLayout(view) {
    if(view.view_type === 'form') {
      return this.createFormLayout(view)
    }

    if(view.view_type === 'custom') {
      return this.pageFactory.createPageLayout()
    }

    return this.createListItemLayout()
  }

  createListItemLayout() {
    let rows = []
    let row1 = this.createRow()
    let primaryField = this.tableUtil.getPrimaryField(this.table)
    row1.columns.push(this.createFieldColumn('12', primaryField))
    rows.push(row1)

    let selectField = this.tableUtil.getSelectField(this.table)

    if(selectField) {
      let row2 = this.createRow()
      row2.columns.push(this.createFieldColumn('12', selectField))
      rows.push(row2)
    }

    let textField = this.tableUtil.getTextField(this.table)

    if(textField) {
      let row3 = this.createRow()
      row3.columns.push(this.createFieldColumn('12', textField))
      rows.push(row3)
    }

    return this.getLayout(rows)
  }

  createDetailedLayout() {

    let rows = []
    let fields = this.table.fields

    for (let i = 0; i < fields.length; i++) {
      let fieldRow = this.createRow()
      fieldRow.columns.push(this.createFieldColumn('12', fields[i]))
      rows.push(fieldRow)
    }

    return this.getLayout(rows)
  }

  createFormLayout(view) {
    let rows = []
    let row = this.createRow()
    row.columns.push(this.createLabelColumn('12', this.table.name + ' Form'))
    rows.push(row)
    let fields = this.table.fields

    for (let i = 0; i < fields.length; i++) {

      let fieldUtil = new FieldUtil(fields[i])

      if( fieldUtil.editable() ) {
        let fieldRow = this.createRow()
        fieldRow.padding.side = 'all'
        fieldRow.padding.value = '1'
        fieldRow.columns.push(this.createFormFieldColumn('12', fields[i]))
        rows.push(fieldRow)
      }
    }

    let buttonRow = this.createRow()

    if(view.layout.type === 'sign up') {
      buttonRow.columns.push(this.createAuthButtonColumn('Sign up', view.layout.type))
    }
    else if(view.layout.type === 'sign in') {
      buttonRow.columns.push(this.createAuthButtonColumn('Sign in', view.layout.type))
    }
    else {
      buttonRow.columns.push(this.createFormButtonsColumn())
    }

    rows.push(buttonRow)
    return this.getLayout(rows)
  }

  getLayout(rows) {
    let layout = {
      rows: rows,
      description: '',
      selectedRow: null,
      selectedColumn: null,
      selectedComponent: null
    }

    return layout
  }

  createRow() {
    return this.pageFactory.createRow()
  }

  createFieldColumn(width, field) {
    let component = this.createFieldComponent(field)
    this.decorateFieldComponent(field, component)
    return this.pageFactory.createColumn(width, component)
  }

  createFormFieldColumn(width, field) {
    let labelComponent = this.createHtmlComponent('Label', field.name)
    let component = this.createFieldComponent(field)
    this.decorateFieldComponent(field, component)
    let column = this.pageFactory.createColumn(width, component)
    column.value = [labelComponent, component] // override value but still reuse createColumn above
    return column
  }

  createFormButtonsColumn() {
    let saveButton = this.createFormButton('Save', 'save', 'primary')
    let cancelButton = this.createFormButton('Cancel', 'back', 'secondary')
    let column = this.pageFactory.createColumn('12', saveButton)
    column.value = [saveButton, cancelButton]
    column.direction = 'row'
    return column
  }

  createAuthButtonColumn(label, action) {
    let button = this.createFormButton(label, action, 'primary')
    let column = this.pageFactory.createColumn('12', button)
    column.value = [button]
    column.direction = 'row'
    return column
  }

  createLabelColumn(width, value) {
    let component = this.createHtmlComponent('Label', value)
    return this.pageFactory.createColumn(width, component)
  }

  decorateFieldComponent(field, fieldComponent) {
    if(field.field_type === 'Image') {
      fieldComponent.metadata = {
        isBackgroundImage: false
      }

      fieldComponent.component = this.pageFactory.createImageComponent('')
    }
    if(field.field_type === 'String') {

      fieldComponent.metadata = {
        renderType: 'Label'
      }

      fieldComponent.component = this.pageFactory.createHtmlComponent('Label', '')
    }
    else if(field.field_type === 'Text') {
      fieldComponent.component = this.pageFactory.createHtmlComponent('Text', '')
    }
    else if(field.field_type === 'Number') {
      fieldComponent.component = this.pageFactory.createHtmlComponent('Number', '')
    }
    else if(field.field_type === 'Single Select') {
      fieldComponent.component = this.pageFactory.createHtmlComponent('Select', '')
    }
  }

  createFieldComponent(field) {
    return {
      type: 'Field',
      value: field,
      margin: {
        side: 'none',
        value: '0'
      },
      padding: {
        side: 'none',
        value: '0'
      },
      selected: false,
      required: false,
      metadata: {},
      component: {},
      style: {}
    }
  }

  createHtmlComponent(type, value) {
    return this.pageFactory.createHtmlComponent(type, value)
  }

  createButton(label) {
    return this.pageFactory.createButton(label)
  }

  createFormButton(label, action, color) {
    let buttonObject = this.pageFactory.createButton(label)
    buttonObject.action = action
    buttonObject.style.color = color
    buttonObject.margin.side = 'right'
    buttonObject.margin.value = '1'
    return buttonObject
  }

  createCondition() {
    let condition = {
      type: 'visible',
      field_id: '',
      predicate: ''
    }

    return condition
  }

  resetColumns(columns) {
    this.pageFactory.resetColumns(columns)
  }
}